import React from 'react';
import logo from '../../assets/images/logo.svg';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from "../../assets/images/dashboard/sideBar/dashboard.svg";
import ActiveDashboard from '../../assets/images/dashboard/sideBar/ActiveDashboard.svg'
import ActiveTasks from '../../assets/images/dashboard/sideBar/ActiveTasks.svg'
import ActiveRequest from '../../assets/images/dashboard/sideBar/ActiveRequests.svg'
import ActiveCoupons from '../../assets/images/dashboard/sideBar/ActiveCoupons.svg'
import Message from "../../assets/images/dashboard/sideBar/tasks.svg";
import Requests from "../../assets/images/dashboard/sideBar/request.svg";
import Coupons from "../../assets/images/dashboard/sideBar/coupons.svg";
import Settings from "../../assets/images/dashboard/sideBar/Setting.svg";
import Accounts from "../../assets/images/dashboard/sideBar/Profile.svg"; // Corrected the path
import Help from "../../assets/images/dashboard/sideBar/help.svg";

const DashboardSideBar = () => {
    const location = useLocation();
    const navigate = useNavigate()

    return (
        <div className='dashboard_sideBar md:fixed '>
            <div>
                <img src={logo} alt="Company logo" className='w-8 ml-5 mt-1 cursor-pointer' onClick={() => navigate("/")} />
            </div>

            <div className='mt-[50px]'>

                <p className='p-3 pl-4 font-bold pt-0 text-xs'>MENU</p>
                {(location.pathname === '/organization/dashboard'
                    || location.pathname === '/organization/requests'
                    || location.pathname === '/organization/coupons'
                ) && (
                        <div>
                            <NavLink className="menu_button" to="/organization/dashboard" >
                            <img src={location.pathname.startsWith('/organization/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                <span>Dashboard</span>
                            </NavLink>

                            <NavLink className="menu_button" to="/organization/requests">
                            <img src={location.pathname.startsWith('/organization/requests') ? ActiveRequest : Requests} alt="Requests" />
                                <span>Requests</span>
                            </NavLink>

                            <NavLink className="menu_button" to="/organization/coupons">
                            <img src={location.pathname.startsWith('/organization/coupons') ? ActiveCoupons : Coupons} alt="Coupons" />
                                <span>Coupons</span>
                            </NavLink>
                        </div>
                    )}

                {(location.pathname === '/admin/dashboard'
                    || location.pathname === '/admin/requests') && (
                        <div>
                            <NavLink className="menu_button" to="/admin/dashboard" >
                            <img src={location.pathname.startsWith('/admin/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                <span>Dashboard</span>
                            </NavLink>

                            <NavLink className="menu_button" to="/admin/requests">
                            <img src={location.pathname.startsWith('/admin/requests') ? ActiveRequest : Requests} alt="Requests" />
                                <span>Requests</span>
                            </NavLink>
                        </div>
                    )}

                {
                    (location.pathname === '/volunteer/dashboard' ||
                        location.pathname === '/volunteer/requests' ||
                        location.pathname === '/volunteer/tasks' ||
                        location.pathname === '/volunteer/coupons'
                    ) && (
                        <div>
                            <NavLink  className="menu_button" to="/volunteer/dashboard">
                                <img src={location.pathname.startsWith('/volunteer/dashboard') ? ActiveDashboard : Dashboard} alt="Dashboard" />
                                <span>Dashboard</span>
                            </NavLink>

                            <NavLink  className="menu_button" to="/volunteer/requests">
                                <img src={location.pathname.startsWith('/volunteer/requests') ? ActiveRequest : Requests} alt="Requests" />
                                <span>Requests</span>
                            </NavLink>

                            <NavLink  className="menu_button" to="/volunteer/tasks">
                                <img src={location.pathname.startsWith('/volunteer/tasks') ? ActiveTasks : Message} alt="Tasks" />
                                <span>Tasks</span>
                            </NavLink>

                            <NavLink  className="menu_button" to="/volunteer/coupons">
                                <img src={location.pathname.startsWith('/volunteer/coupons') ? ActiveCoupons : Coupons} alt="Coupons" />
                                <span>Coupons</span>
                            </NavLink>
                        </div>
                    )}



                <p className='p-3 pl-4 font-bold pt-4 text-xs'>OTHERS</p>

                <span className="menu_button" >
                    <img src={Settings} alt="Settings" />
                    <span>Settings</span>
                </span>

                <span className="menu_button" >
                    <img src={Accounts} alt="Accounts" />
                    <span>Accounts</span>
                </span>

                <span className="menu_button" >
                    <img src={Help} alt="Help" />
                    <span>Help</span>
                </span>
            </div>
        </div>
    );
}

export default DashboardSideBar;
